
import BookMotFormCity from '@/components/modules/BookMotFormCity';
import loader from '@/components/loader'

export default {
    scrollToTop: true,
    components: {
        BookMotFormCity,
        loader
    },
    data() {
        return {
            stationName: null,
            stationId: null,
            city: null,
            station: null,
            loading: true
        };
    },
    head() {
        return {
            title: `MOT Center ${this.city} | Check MOT | ${this.stationName} | Book MOT Online`,
            meta: [
                {
                    hid: "og:title",
                    property: "og:title",
                    content: `MOT Center ${this.city} | Check MOT | ${this.stationName} | Book MOT Online`
                },
                {
                    hid: "twitter:title",
                    property: "twitter:title",
                    content: `MOT Center ${this.city} | Check MOT | ${this.stationName} | Book MOT Online`
                },
            ],
        };
    },
    async validate({ params, store }) {
        // await operations
        if (params.station != (null || "")) {
            this.stationName = params.station;
            this.stationId = params.id;
            this.city = params.city;
            return true; // if the params are valid
        }
        else {
            return false; // will stop Nuxt.js to render the route and display the error page
        }
    },
    created() {
        this.stationName = this.$route.params.station;
        this.stationId = this.$route.params.id;
        this.city = this.$route.params.city;
    },
    async fetch() {
        // Get station data
        if (this.stationId) {
            this.station = await fetch(this.$config.fetchUrl + "/api/stations/getStationDetailsById/" + this.stationId).then(res => res.json()).catch(error => {
                console.error("There was an error!", error);
                this.$router.push({
                    path: "/mot-center-cities"
                });
            });
        } else {
            this.station = await fetch(this.$config.fetchUrl + "/api/stations/getStationDetails/" + this.stationName).then(res => res.json()).catch(error => {
                console.error("There was an error!", error);
                this.$router.push({
                    path: "/mot-center-cities"
                });
            });
        }
        this.loading = false;

    },
    mounted() {
        if (this.station && !this.isMyScriptLoaded('https://maps.googleapis.com/maps/api/js?key=AIzaSyCKmgkypgUiiDyqTBZ5Wy-uO_va66nhkaI')) {
            // First check if the script already exists on the dom
            // by searching for an id
            let id = 'googleMap'
            if (document.getElementById(id) != null) {
                let script = document.createElement('script')
                script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCKmgkypgUiiDyqTBZ5Wy-uO_va66nhkaI')
                script.setAttribute('id', id)
                document.body.appendChild(script)
                // now wait for it to load...
                script.onload = () => {
                    // script has loaded, you can now use it safely
                    this.createMap();
                    // ... do something with the newly loaded script
                }
            }
        }

    },

    updated() {
        if (this.station && !this.isMyScriptLoaded('https://maps.googleapis.com/maps/api/js?key=AIzaSyCKmgkypgUiiDyqTBZ5Wy-uO_va66nhkaI')) {
            // First check if the script already exists on the dom
            // by searching for an id
            let id = 'googleMap'

            if (document.getElementById(id) != null) {
                let script = document.createElement('script')
                script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCKmgkypgUiiDyqTBZ5Wy-uO_va66nhkaI')
                script.setAttribute('id', id)
                document.body.appendChild(script)
                // now wait for it to load...
                script.onload = () => {
                    // script has loaded, you can now use it safely
                    this.createMap();
                    // ... do something with the newly loaded script
                }
            }
        }

       else if (this.isMyScriptLoaded('https://maps.googleapis.com/maps/api/js?key=AIzaSyCKmgkypgUiiDyqTBZ5Wy-uO_va66nhkaI') && this.station) {
            this.createMap();
        }

    },

    methods: {

        isMyScriptLoaded(url) {
            if (!url) url = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCKmgkypgUiiDyqTBZ5Wy-uO_va66nhkaI";
            var scripts = document.getElementsByTagName('script');
            for (var i = scripts.length; i--;) {
                if (scripts[i].src == url) return true;
            }
            return false;
        },
        createMap() {
            var e = document.getElementById("lat").innerText,
                n = document.getElementById("lng").innerText,
                t = {
                    center: new google.maps.LatLng(e, n),
                    zoom: 18
                },
                o = new google.maps.Map(document.getElementById("googleMap"), t);
            new google.maps.Marker({
                position: {
                    lat: parseFloat(e),
                    lng: parseFloat(n)
                },
                map: o
            })
        },

        addressSplit(address) {
            var value = address.split(',') && address.split(',').length > 0 ? address.split(',') : [];
            value = value.filter(item => item);
            return value
        },

        // To add a fallback placeholder image if not rendereds from API
        setFallbackImageUrl(event) {
            event.target.src = require(`@/assets/img/footer/mot-logo.svg`)
        },

    }

};

